import { useState } from "react";
import Card from "@/components/base/Card";
import Badge from "@/components/base/Badge";

export default function ResumenIndicadoresPage() {
  const [period, setPeriod] = useState("mes");
  
  return (
    <div className="p-4 md:p-6 space-y-6 animate-fade-in-up">
      <div className="flex flex-col sm:flex-row gap-3 items-start sm:items-center justify-between">
        <div>
          <h1 className="text-xl md:text-2xl font-bold text-foreground-950">Indicadores Clave</h1>
          <p className="text-sm text-foreground-500 mt-0.5">Visualización de KPIs institucionales, tendencias y comparativas de convivencia escolar.</p>
        </div>
        <div className="flex bg-background-100 p-0.5 rounded-lg border border-background-200">
          {["semana", "mes", "ano"].map((p) => (
            <button
              key={p}
              onClick={() => setPeriod(p)}
              className={`px-3.5 py-1 rounded-md text-xs font-semibold cursor-pointer transition-colors ${
                period === p ? "bg-white text-foreground-900 shadow-sm" : "text-foreground-400 hover:text-foreground-900"
              }`}
            >
              {p === "semana" ? "Semanal" : p === "mes" ? "Mensual" : "Anual"}
            </button>
          ))}
        </div>
      </div>

      {/* Stats Cards */}
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        
        <div className="bg-white border border-background-200/80 rounded-2xl p-4 shadow-sm relative overflow-hidden group hover:shadow-md transition-all duration-300">
          <div className="flex items-center justify-between">
            <span className="text-xs font-semibold uppercase tracking-wider text-foreground-400">Casos Totales</span>
            <div className="w-8 h-8 rounded-xl bg-primary-50 text-primary-600 flex items-center justify-center text-lg">
              <i className="ri-folder-line" />
            </div>
          </div>
          <div className="mt-3 flex items-baseline gap-2">
            <span className="text-2xl font-bold text-foreground-900">42</span>
            <span className="text-xs font-medium text-emerald-600 flex items-center gap-0.5">
              <i className="ri-arrow-up-line" /> +12%
            </span>
          </div>
          <p className="text-2xs text-foreground-400 mt-1">Registrados en el ciclo escolar</p>
        </div>

        <div className="bg-white border border-background-200/80 rounded-2xl p-4 shadow-sm relative overflow-hidden group hover:shadow-md transition-all duration-300">
          <div className="flex items-center justify-between">
            <span className="text-xs font-semibold uppercase tracking-wider text-foreground-400">Resolución</span>
            <div className="w-8 h-8 rounded-xl bg-primary-50 text-primary-600 flex items-center justify-center text-lg">
              <i className="ri-check-line" />
            </div>
          </div>
          <div className="mt-3 flex items-baseline gap-2">
            <span className="text-2xl font-bold text-foreground-900">88%</span>
            <span className="text-xs font-medium text-emerald-600 flex items-center gap-0.5">
              <i className="ri-arrow-up-line" /> +3%
            </span>
          </div>
          <p className="text-2xs text-foreground-400 mt-1">Casos cerrados a tiempo</p>
        </div>

        <div className="bg-white border border-background-200/80 rounded-2xl p-4 shadow-sm relative overflow-hidden group hover:shadow-md transition-all duration-300">
          <div className="flex items-center justify-between">
            <span className="text-xs font-semibold uppercase tracking-wider text-foreground-400">Alerta Roja</span>
            <div className="w-8 h-8 rounded-xl bg-primary-50 text-primary-600 flex items-center justify-center text-lg">
              <i className="ri-alert-line" />
            </div>
          </div>
          <div className="mt-3 flex items-baseline gap-2">
            <span className="text-2xl font-bold text-foreground-900">3</span>
            <span className="text-xs font-medium text-emerald-600 flex items-center gap-0.5">
              <i className="ri-arrow-up-line" /> -25%
            </span>
          </div>
          <p className="text-2xs text-foreground-400 mt-1">Requieren atención urgente</p>
        </div>

        <div className="bg-white border border-background-200/80 rounded-2xl p-4 shadow-sm relative overflow-hidden group hover:shadow-md transition-all duration-300">
          <div className="flex items-center justify-between">
            <span className="text-xs font-semibold uppercase tracking-wider text-foreground-400">Derivados</span>
            <div className="w-8 h-8 rounded-xl bg-primary-50 text-primary-600 flex items-center justify-center text-lg">
              <i className="ri-share-forward-line" />
            </div>
          </div>
          <div className="mt-3 flex items-baseline gap-2">
            <span className="text-2xl font-bold text-foreground-900">14</span>
            <span className="text-xs font-medium text-emerald-600 flex items-center gap-0.5">
              <i className="ri-arrow-up-line" /> +5%
            </span>
          </div>
          <p className="text-2xs text-foreground-400 mt-1">A redes de apoyo externas</p>
        </div>
      </div>

      {/* Charts Grid */}
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        <Card className="lg:col-span-2 space-y-4">
          <div className="flex items-center justify-between">
            <h3 className="font-semibold text-foreground-900">Histórico de Tendencias</h3>
            <span className="text-xs text-foreground-400">Distribución temporal de registros</span>
          </div>
          {/* Beautiful SVG Line Chart */}
          <div className="h-60 w-full flex items-end">
            <svg className="w-full h-full" viewBox="0 0 500 200" preserveAspectRatio="none">
              <defs>
                <linearGradient id="chart-grad-ResumenIndicadoresPage" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="0%" stopColor="#3b82f6" stopOpacity="0.25"/>
                  <stop offset="100%" stopColor="#3b82f6" stopOpacity="0.0"/>
                </linearGradient>
              </defs>
              <path d="M 0 160 Q 100 120 180 140 T 350 60 T 500 40 L 500 200 L 0 200 Z" fill="url(#chart-grad-ResumenIndicadoresPage)" />
              <path d="M 0 160 Q 100 120 180 140 T 350 60 T 500 40" fill="none" stroke="#3b82f6" strokeWidth="3" strokeLinecap="round" />
              {/* Grid Lines */}
              <line x1="0" y1="50" x2="500" y2="50" stroke="#f1f5f9" strokeDasharray="4 4" />
              <line x1="0" y1="100" x2="500" y2="100" stroke="#f1f5f9" strokeDasharray="4 4" />
              <line x1="0" y1="150" x2="500" y2="150" stroke="#f1f5f9" strokeDasharray="4 4" />
            </svg>
          </div>
          <div className="flex justify-between text-xs text-foreground-400 px-1">
            <span>Ene</span><span>Mar</span><span>May</span><span>Jul</span><span>Sep</span><span>Nov</span>
          </div>
        </Card>
        <Card className="space-y-4">
          <h3 className="font-semibold text-foreground-900">Distribución por Categorías</h3>
          <div className="space-y-4 pt-2">
            
            <div className="space-y-1">
              <div className="flex justify-between text-xs">
                <span className="font-medium text-foreground-700">Ciberacoso / Bullying</span>
                <span className="font-semibold text-foreground-900">35%</span>
              </div>
              <div className="w-full h-2 bg-background-100 rounded-full overflow-hidden">
                <div className="h-full bg-primary-500 rounded-full" style={{ width: '35%', backgroundColor: '#3b82f6' }} />
              </div>
            </div>

            <div className="space-y-1">
              <div className="flex justify-between text-xs">
                <span className="font-medium text-foreground-700">Desregulación Conductual</span>
                <span className="font-semibold text-foreground-900">25%</span>
              </div>
              <div className="w-full h-2 bg-background-100 rounded-full overflow-hidden">
                <div className="h-full bg-primary-500 rounded-full" style={{ width: '25%', backgroundColor: '#3b82f6' }} />
              </div>
            </div>

            <div className="space-y-1">
              <div className="flex justify-between text-xs">
                <span className="font-medium text-foreground-700">Conflictos Escolares</span>
                <span className="font-semibold text-foreground-900">20%</span>
              </div>
              <div className="w-full h-2 bg-background-100 rounded-full overflow-hidden">
                <div className="h-full bg-primary-500 rounded-full" style={{ width: '20%', backgroundColor: '#3b82f6' }} />
              </div>
            </div>

            <div className="space-y-1">
              <div className="flex justify-between text-xs">
                <span className="font-medium text-foreground-700">Incumplimiento de Deberes</span>
                <span className="font-semibold text-foreground-900">15%</span>
              </div>
              <div className="w-full h-2 bg-background-100 rounded-full overflow-hidden">
                <div className="h-full bg-primary-500 rounded-full" style={{ width: '15%', backgroundColor: '#3b82f6' }} />
              </div>
            </div>

            <div className="space-y-1">
              <div className="flex justify-between text-xs">
                <span className="font-medium text-foreground-700">Otros casos</span>
                <span className="font-semibold text-foreground-900">5%</span>
              </div>
              <div className="w-full h-2 bg-background-100 rounded-full overflow-hidden">
                <div className="h-full bg-primary-500 rounded-full" style={{ width: '5%', backgroundColor: '#3b82f6' }} />
              </div>
            </div>
          </div>
        </Card>
      </div>

      {/* Bottom Table */}
      <Card padding="none">
        <div className="p-4 border-b border-background-150 flex items-center justify-between">
          <h3 className="font-semibold text-foreground-900">Resumen Detallado</h3>
          <Badge variant="primary">KPI Actualizado</Badge>
        </div>
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b border-background-200 bg-background-50/50">
                <th className="text-left py-3.5 px-4 text-foreground-500 font-semibold text-xs uppercase tracking-wider">Indicador</th>
<th className="text-left py-3.5 px-4 text-foreground-500 font-semibold text-xs uppercase tracking-wider">Meta Anual</th>
<th className="text-left py-3.5 px-4 text-foreground-500 font-semibold text-xs uppercase tracking-wider">Estado</th>
<th className="text-left py-3.5 px-4 text-foreground-500 font-semibold text-xs uppercase tracking-wider">Último Registro</th>
              </tr>
            </thead>
            <tbody>
              <tr className="border-b border-background-50 hover:bg-background-50/50 transition-colors"><td className="py-3 px-4 font-semibold text-foreground-900">Tasa de Bullying Escolar</td>
<td className="py-3 px-4 text-foreground-600 text-xs">Menos de 10%</td>
<td className="py-3 px-4"><Badge variant="primary">Bajo Control</Badge></td>
<td className="py-3 px-4 text-foreground-600 text-xs">2026-06-10</td></tr>
<tr className="border-b border-background-50 hover:bg-background-50/50 transition-colors"><td className="py-3 px-4 font-semibold text-foreground-900">Tiempos de Respuesta</td>
<td className="py-3 px-4 text-foreground-600 text-xs">Bajo 5 días</td>
<td className="py-3 px-4"><Badge variant="warning">En Línea</Badge></td>
<td className="py-3 px-4 text-foreground-600 text-xs">2026-06-08</td></tr>
<tr className="border-b border-background-50 hover:bg-background-50/50 transition-colors"><td className="py-3 px-4 font-semibold text-foreground-900">Participación de Padres</td>
<td className="py-3 px-4 text-foreground-600 text-xs">Mayor al 90%</td>
<td className="py-3 px-4"><Badge variant="danger">Atención</Badge></td>
<td className="py-3 px-4 text-foreground-600 text-xs">2026-06-05</td></tr>
            </tbody>
          </table>
        </div>
      </Card>
    </div>
  );
}
